import {Event, KeyEvent, ProcessedEvent, ProcessedEventV2} from "../dtos/eventResponse"
import * as Order from "../dtos/orderResponse"

export function processEventsData(events: Event[], order: Order.Order) {
	let processedEvents = [] as ProcessedEvent[]
	let event: any
	for (event of events) {
		let processedEvent = {} as ProcessedEvent
		processedEvent.type = event.type
		processedEvent.dateTime = event.dateTime
		if (event.itemInfo && event.itemInfo[0]) {
			processedEvent.itemId = event.itemInfo[0].itemId
			// eslint-disable-next-line
			processedEvent.productName = order.orderData.lineItems.find(
				// eslint-disable-next-line
				(lineItem: Order.LineItem) => lineItem.id === event.itemInfo[0].itemId
			)!.productName
		}

		let details = "" as string

		if (event.eventTypeDescription && event.eventTypeDescription !== undefined) {
			details += "Description: " + event.eventTypeDescription + "\n"
		}
		if (event.source && event.source !== undefined) {
			details += "Source: " + event.source + "\n"
		}
		if (
			event.eventProperties &&
			event.eventProperties !== undefined &&
			event.eventProperties.reason !== undefined
		) {
			details += "Specialist logged reason: " + event.eventProperties.reason + "\n"
		}
		if (
			event.eventProperties &&
			event.eventProperties !== undefined &&
			event.eventProperties.eventSubType !== undefined
		) {
			details += "Event Sub Type: " + event.eventProperties.eventSubType.replace(/([A-Z])/g, " $1")
		}
		if (
			event.eventProperties &&
			event.eventProperties !== undefined &&
			event.eventProperties.details !== undefined &&
			event.eventProperties.details[0].additionalData !== undefined &&
			event.eventProperties.details[0].additionalData.reason !== undefined
		) {
			details += "Reason:" + event.eventProperties.details[0].additionalData.reason
		}
		if (
			event.eventProperties &&
			event.eventProperties.mcpEvent !== undefined &&
			JSON.parse(event.eventProperties.mcpEvent[0]).eventType === "fulfillerRejected" &&
			JSON.parse(event.eventProperties.mcpEvent[0]).fulfillerRejectedDetails !== undefined &&
			JSON.parse(event.eventProperties.mcpEvent[0]).fulfillerRejectedDetails[0].additionalInfo !==
				undefined
		) {
			details +=
				"Rejection reason: " +
				JSON.parse(event.eventProperties.mcpEvent[0]).fulfillerRejectedDetails[0].additionalInfo
		}
		processedEvent.details = details
		processedEvents.push(processedEvent)
	}
	return processedEvents
}

export function processEventsDataV2(keyEvents: KeyEvent[]) {
	let processedEvents = [] as ProcessedEventV2[]
	keyEvents.forEach((keyEvent) => {
		let processedEvent = {} as ProcessedEventV2
		const event = keyEvent.event
		if (event) {
			processedEvent.type = event.type
			processedEvent.dateTime = event.dateTime
			processedEvent.description = event.eventTypeDescription
			processedEvent.source = event.source
			processedEvent.tag = keyEvent.tag
			if (
				event.eventProperties &&
				event.eventProperties !== undefined &&
				event.eventProperties.eventSubType !== undefined
			) {
				processedEvent.eventSubType = event.eventProperties.eventSubType.replace(/([A-Z])/g, " $1")
			}
			if (
				event.eventProperties &&
				event.eventProperties !== undefined &&
				event.eventProperties.details !== undefined &&
				event.eventProperties.details[0].additionalData !== undefined &&
				event.eventProperties.details[0].additionalData.reason !== undefined
			) {
				processedEvent.reason = event.eventProperties.details[0].additionalData.reason
			}
			processedEvents.push(processedEvent)
		}
	})
	return processedEvents
}
